module.exports = __webpack_public_path__ + "static/media/desktopScreenshot01.67475a97.jpg";